import React from 'react';
import { Button, Text } from '~/components';

import useAppNavigation from '~/hooks/useAppNavigation';
import { callNumber, openEmail } from '~/utils/device';
import { Components } from '~/scenes/HiredInsurance/components';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import DefaultContainer from '../../components/DefaultContainer';

const SAO_PAULO_PHONE = '11 2110 7720';
const OTHER_STATES_PHONE = '0800 591 3676';
const CONTACT_EMAIL = 'contato@assegurou.com.br';
const ASSEGUROU_WEBSITE = 'https://assegurou.com.br/';

const HiredInsuranceCancelAuto: React.FC = () => {
  const { goBack } = useAppNavigation();

  return (
    <DefaultContainer type="marisa-auto" className="pt-6 pb-12">
      <Components.CancelStatus type="alert" />

      <Text className="text-xl text-gray-700 text-center mb-6">
        Você quer mesmo cancelar o{' '}
        <Text className="text-primary-600">Seguro Auto</Text>?
      </Text>

      <Text className="text-center text-sm text-gray-400 mb-6">
        Para cancelar entre em contato com a{' '}
        <Text
          className="text-primary-600"
          onPress={() => MarisaAppUtils.openUrl(ASSEGUROU_WEBSITE)}
        >
          Assegurou
        </Text>{' '}
        de segunda à sexta das 8h as 17h ou se preferir envie e-mail.
      </Text>

      <Text className="text-sm text-gray-400 text-center">
        São Paulo:{' '}
        <Text
          className="text-primary-600"
          onPress={() => callNumber(SAO_PAULO_PHONE)}
        >
          {SAO_PAULO_PHONE}
        </Text>{' '}
        ramal 7772
      </Text>
      <Text className="text-sm text-gray-400 text-center">
        Outros estados:{' '}
        <Text
          className="text-primary-600"
          onPress={() => callNumber(OTHER_STATES_PHONE)}
        >
          {OTHER_STATES_PHONE}
        </Text>
      </Text>
      <Text className="text-sm text-gray-400 text-center">
        e-mail:{' '}
        <Text
          className="text-primary-600"
          onPress={() => openEmail(CONTACT_EMAIL)}
        >
          {CONTACT_EMAIL}
        </Text>
      </Text>

      <Button variant="tertiary" className="mt-9" onPress={goBack}>
        VOLTAR
      </Button>
    </DefaultContainer>
  );
};

export default HiredInsuranceCancelAuto;
